import React from "react";
import "./AnimatedLink.css";
import { Link } from "react-router-dom";

const AnimatedLink = ({ text, href, className, handleMenu }) => {
  return (
    <Link to={href} className="link" onClick={handleMenu}>
      {text.split("").map((letter, index) => {
        if (letter === " ") {
          return (
            <span key={index} className="space">
              &nbsp;
            </span>
          );
        }

        return (
          <span
            className="letter"
            key={index}
            style={{ "--delay": `${index * 0.05}s` }}
          >
            <span>{letter}</span>
            <span>{letter}</span>
          </span>
        );
      })}
    </Link>
  );
};

export default AnimatedLink;
